import { render, staticRenderFns } from "./currency-switch.vue?vue&type=template&id=02b7327a"
import script from "./currency-switch.vue?vue&type=script&lang=js"
export * from "./currency-switch.vue?vue&type=script&lang=js"
import style0 from "./currency-switch.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports